import { useReadContract } from 'wagmi';
import { contractAddress } from '../config/contract';
import { abi } from '../abi';
import { abiBSC } from '../abiBSC';
import { formatUnits } from 'viem';
import { useState, useEffect } from 'react';

export function useGgapPrice(network: 'eth' | 'bsc' | 'sol' = 'eth') {
  const [priceUSD, setPriceUSD] = useState<number>(0.002);
  const [loading, setLoading] = useState<boolean>(true);

  // For Ethereum and BSC, get token price from contract
  const { data: tokenPriceUSD, isLoading: contractLoading } = useReadContract({
    address: contractAddress[network === 'sol' ? 'eth' : network as 'eth' | 'bsc'],
    abi: network === 'bsc' ? abiBSC : abi,
    functionName: 'tokenPriceUSD',
    // Skip if using Solana 
    query: {
      enabled: network !== 'sol'
    }
  });

  useEffect(() => {
    if (network === 'sol') {
      // For Solana, we use a fixed price or can fetch from elsewhere
      setPriceUSD(0.002); // Fixed price for Solana
      setLoading(false);
    } else {
      // For EVM chains, use the contract data
      if (tokenPriceUSD) {
        // Calculate price in USD (contract returns price with 18 decimals)
        const price = Number(formatUnits(tokenPriceUSD as bigint, 18));
        setPriceUSD(price);
        setLoading(false);
      } else if (!contractLoading) {
        // If loaded but no data, use default price
        setPriceUSD(0.002);
        setLoading(false);
      }
    }
  }, [tokenPriceUSD, contractLoading, network]);
  
  return {
    priceUSD,
    loading
  };
}